module.exports = __webpack_public_path__ + "static/media/campanha_instrucoes.d5765495.png";